import {texture} from "p3";
import GameScene from "../../../scenes/GameScene";
import {locale, resizeLabelToFitText} from "../../../utils";

export default class MinigameTracker extends PIXI.Container {
    constructor() {
        super();

        this._frame = null;
        this._timer = null;

        this._nameLabel = null;
        this._descriptionLabel = null;

        this._timerRadius = 35;
        this._timerProgress = 0;
        this._timerProgressEase = 0;
        this._timerProgressSmooth = 100;

        this.init();
    }

    init() {
        this._frame = new PIXI.Sprite(texture("panel_progess_tracker"));
        this.addChild(this._frame);

        this.pivot.set(this._frame.texture.width * 0.5, this._frame.texture.height * 0.5);

        this._nameLabel = new PIXI.BitmapText("", {
            fontName: "Alghera Pro",
            fontSize: 26,
            align: "left",
            tint: 0x732612
        });
        this._nameLabel.position.set(86, 44);
        this._nameLabel.anchor.set(0, 1);
        this.addChild(this._nameLabel);
        resizeLabelToFitText(this._nameLabel, 220);

        this._descriptionLabel = new PIXI.BitmapText("", {
            fontName: "Alghera Pro",
            fontSize: 20,
            align: "left",
            tint: 0x732612,
            maxWidth: 300
        });
        this._descriptionLabel.position.set(86, 50);
        this._descriptionLabel.anchor.set(0, 0);
        this.addChild(this._descriptionLabel);
        resizeLabelToFitText(this._descriptionLabel, 260);

        this._timer = new PIXI.Sprite(texture("timer_brown"));
        this._timer.position.set(40, 43);
        this._timer.anchor.set(0.5);
        this.addChild(this._timer);

        /*
        this._timer.fill = new PIXI.Sprite(texture("timer_yellow"));
        this._timer.fill.anchor.set(0.5);
        this._timer.addChild(this._timer.fill);
        */

        this._timer.fill = new PIXI.Container();
        this._timer.addChild(this._timer.fill);
        this._timer.fill.segments = [];
        for( let i = 0; i < 30; i ++) {
            let spr = new PIXI.Sprite(texture('timer_yellow_segment'));
            spr.anchor.set(0.5);
            spr.rotation = i * (12 * PIXI.DEG_TO_RAD);
            this._timer.fill.addChild(spr);
            this._timer.fill.segments.push(spr);
        }

        this._timer.label = new PIXI.BitmapText("99", {
            fontName: "Alghera Pro",
            fontSize: 30,
            align: "center",
            tint: 0x632718
        });
        this._timer.label.position.set(0, 3);
        this._timer.label.anchor.set(0.5);
        this._timer.addChild(this._timer.label);

        /*
        this._timer.fill.mask = new PIXI.Graphics();
        this._timer.addChild(this._timer.fill.mask);
        */
    }

    update() {
        this._timerProgressEase += (this._timerProgress - this._timerProgressEase) * this._timerProgressSmooth * window.dt;

        /* Note: This method causes issues on some mobiles
        const startAngle = -Math.PI * 0.5;
        const endAngle = startAngle + Math.PI * 2 * this._timerProgressEase;

        this._timer.fill.mask.clear();
        this._timer.fill.mask.beginFill(0xFF0000);
        this._timer.fill.mask.moveTo(0, 0);
        this._timer.fill.mask.arc(0, 0, this._timerRadius, startAngle, endAngle, false);
        this._timer.fill.mask.lineTo(0, 0);
        this._timer.fill.mask.endFill();*/



        /* Note: this method works, but flickers on mobile (as does the previous one)
        this._timer.fill.mask.clear();
        this._timer.fill.mask.beginFill(0xFF0000);
    
        var degreeAmount = 360 / 60;
        var distance = this._timerRadius;
    
        for(var i = 60; i >= 0; i--){
            if(i < this._timerProgressEase * 60){
                var angle1 = (degreeAmount * i);
                var angle2 = (angle1 - degreeAmount);
    
                angle1 = angle1 * PIXI.DEG_TO_RAD;
                angle2 = angle2 * PIXI.DEG_TO_RAD;
    
                this._timer.fill.mask.moveTo(0, 0);
                this._timer.fill.mask.lineTo( -1 * (-Math.sin(angle1) * distance), -1 * (Math.cos(angle1) * distance) );
                this._timer.fill.mask.lineTo( -1 * (-Math.sin(angle2) * distance), -1 * (Math.cos(angle2) * distance) );
                this._timer.fill.mask.lineTo(0, 0);
            }
        }
        this._timer.fill.mask.endFill();
        */

        for( let i = this._timer.fill.segments.length-1; i >= 0; i--) {
            this._timer.fill.segments[i].visible = i / (this._timer.fill.segments.length - 1) > this._timerProgressEase;
        }
    }

    /**
     * @return {Promise}
     */
    animateIn() {
        return new Promise((resolve) => {
            this.scale.set(0);
            this.alpha = 1;

            GameScene.active.addTween(gsap.to(this.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: () => this.visible = true,
                onComplete: resolve
            }));
        });
    }

    /**
     * @return {Promise}
     */
    animateOut() {
        return new Promise((resolve) => {
            GameScene.active.addTween(gsap.to(this.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                onComplete: () => {
                    this.visible = true;
                    resolve();
                }
            }));
        });
    }

    /**
     * @param {string} text
     */
    setName(text) {
        this._nameLabel.text = locale(text);
    }

    /**
     * @param {string} text
     */
    setDescription(text) {
        this._descriptionLabel.text = locale(text);
        this._frame.height = this._descriptionLabel.textHeight + this._timer.height;
    }

    /**
     * @param {number} time
     * @param {number} duration
     * @param {boolean} [animate=false]
     */
    setTime(time, duration, animate= false) {
        this._timerProgress = 1 - (time / duration);
        this._timer.label.text = Math.round(duration - time) + "";

        if (!animate) {
            this._timerProgressEase = this._timerProgress;
        }
    }
}